(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunjunkie-complete-your-kit"] && !Shopify.designMode) return;
  try {
    
  class SjCompleteKit extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.sj-kit-add-btn, .sj-kit-add-btn-m').forEach(btn => {
        btn.addEventListener('click', this._onAdd.bind(this));
      });
    }

    async _onAdd(e) {
      const btn = e.currentTarget;
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      const original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="14" height="14" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'complete-kit', resource: cart } }));
        setTimeout(() => { btn.disabled = false; btn.innerHTML = original; }, 1800);
      } catch {
        btn.disabled = false;
        btn.innerHTML = original;
      }
    }
  }

  if (!customElements.get('sj-complete-kit')) customElements.define('sj-complete-kit', SjCompleteKit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunjunkie-ingredients"] && !Shopify.designMode) return;
  try {
    
  class SjIngPills extends HTMLElement {
    connectedCallback() {
      this._panels = Array.from(this.querySelectorAll('[data-ing-panel]'));
      this.querySelectorAll('.sj-ing-pill').forEach(pill => {
        pill.addEventListener('click', this._onPill.bind(this));
      });
    }

    _onPill(e) {
      const pill = e.currentTarget;
      const idx = pill.dataset.index;
      const isActive = pill.classList.contains('is-active');

      this.querySelectorAll('.sj-ing-pill').forEach(p => {
        p.classList.remove('is-active');
        p.setAttribute('aria-expanded', 'false');
      });
      this._panels.forEach(panel => { panel.hidden = true; });

      if (!isActive) {
        pill.classList.add('is-active');
        pill.setAttribute('aria-expanded', 'true');
        const panel = this.querySelector(`[data-ing-panel="${idx}"]`);
        if (panel) panel.hidden = false;
      }
    }
  }

  class SjIngAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.sj-ing-item__trigger').forEach(trigger => {
        trigger.addEventListener('click', this._onTrigger.bind(this));
      });
    }

    _onTrigger(e) {
      const trigger = e.currentTarget;
      const item = trigger.closest('.sj-ing-item');
      const isOpen = item.classList.contains('is-open');

      this.querySelectorAll('.sj-ing-item.is-open').forEach(open => {
        open.classList.remove('is-open');
        const t = open.querySelector('.sj-ing-item__trigger');
        const p = open.querySelector('.sj-ing-item__panel');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (p) p.setAttribute('aria-hidden', 'true');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        const panel = item.querySelector('.sj-ing-item__panel');
        if (panel) panel.setAttribute('aria-hidden', 'false');
      }
    }
  }

  if (!customElements.get('sj-ing-pills')) customElements.define('sj-ing-pills', SjIngPills);
  if (!customElements.get('sj-ing-accordion')) customElements.define('sj-ing-accordion', SjIngAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunjunkie-main-product"] && !Shopify.designMode) return;
  try {
    
  class SjProductForm extends HTMLElement {
    _variants = [];
    _basePrice = 0;
    _currentOptions = {};

    connectedCallback() {
      const sectionId = this.dataset.sectionId;
      const variantsEl = document.getElementById('sj-variants-' + sectionId);
      if (variantsEl) {
        try { this._variants = JSON.parse(variantsEl.textContent); } catch(e) {}
      }
      this._basePrice = parseInt(this.dataset.basePrice || '0', 10);

      this.querySelectorAll('[data-option-index]').forEach(group => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        const sel = group.querySelector('.is-selected');
        if (sel) this._currentOptions[idx] = sel.dataset.optionValue;
      });

      this.querySelectorAll('.sj-dha-option, .sj-size-btn').forEach(btn => {
        btn.addEventListener('click', this._onOption);
      });

      this.querySelectorAll('.sj-addon-card__checkbox').forEach(cb => {
        cb.addEventListener('change', this._onAddon);
      });

      this._initQtyStepper();

      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', this._onSubmit);

      this._initStickyObserver();
    }

    _initQtyStepper() {
      const input = this.querySelector('.sj-qty-input');
      if (!input) return;
      const decBtn = this.querySelector('[data-qty-action="decrease"]');
      const incBtn = this.querySelector('[data-qty-action="increase"]');
      const update = () => {
        const val = parseInt(input.value) || 1;
        const min = parseInt(input.min) || 1;
        if (decBtn) decBtn.disabled = val <= min;
      };
      if (decBtn) decBtn.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        const min = parseInt(input.min) || 1;
        if (val > min) { input.value = val - 1; update(); }
      });
      if (incBtn) incBtn.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
        update();
      });
      input.addEventListener('change', update);
      update();
    }

    _onOption = (e) => {
      const btn = e.currentTarget;
      const group = btn.closest('[data-option-index]');
      if (!group) return;
      const idx = parseInt(group.dataset.optionIndex, 10);

      group.querySelectorAll('[role="radio"]').forEach(b => {
        const sel = b === btn;
        b.classList.toggle('is-selected', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
      });

      group.querySelectorAll('.sj-dha-check').forEach(c => c.remove());
      if (btn.classList.contains('sj-dha-option')) {
        const chk = document.createElement('span');
        chk.className = 'sj-dha-check';
        chk.setAttribute('aria-hidden', 'true');
        chk.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>';
        btn.prepend(chk);
      }

      this._currentOptions[idx] = btn.dataset.optionValue;
      this._updateVariant();
    };

    _updateVariant() {
      const variant = this._findVariant();
      if (!variant) return;
      this._basePrice = variant.price;

      const input = document.getElementById('sj-variant-id-' + this.dataset.sectionId);
      if (input) input.value = variant.id;

      this._updateAtcText(variant);
      this._updateAtcState(variant);
      this._updateDhaPill();
      this._updateStickyInfo(variant);
    }

    _findVariant() {
      return this._variants.find(v =>
        Object.entries(this._currentOptions).every(([idx, val]) =>
          v.options[parseInt(idx, 10)] === val
        )
      );
    }

    _calcTotal() {
      let total = this._basePrice;
      this.querySelectorAll('.sj-addon-card__checkbox:checked').forEach(cb => {
        total += parseInt(cb.dataset.price || '0', 10);
      });
      return total;
    }

    _formatMoney(cents) {
      const amount = cents / 100;
      return '£' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
    }

    _updateAtcText(variant) {
      const btn = document.getElementById('sj-atc-btn-' + this.dataset.sectionId);
      const text = btn?.querySelector('.sj-atc-btn__text');
      if (!text || !btn) return;
      if (variant.available) {
        const label = (btn.dataset.addText || 'ADD TO CART').toUpperCase();
        text.textContent = label + ' · ' + this._formatMoney(this._calcTotal());
      } else {
        text.textContent = 'SOLD OUT';
      }
    }

    _updateAtcState(variant) {
      const btn = document.getElementById('sj-atc-btn-' + this.dataset.sectionId);
      if (!btn) return;
      btn.disabled = !variant.available;
      btn.classList.toggle('sj-atc-btn--sold-out', !variant.available);
    }

    _updateDhaPill() {
      const pill = document.getElementById('sj-dha-pill-' + this.dataset.sectionId);
      const picker = this.querySelector('.sj-dha-picker');
      if (!pill || !picker) return;
      const idx = parseInt(picker.dataset.optionIndex, 10);
      pill.textContent = this._currentOptions[idx] || '';
    }

    _updateStickyInfo(variant) {
      const priceEl = document.getElementById('sj-sticky-price-' + this.dataset.sectionId);
      const variantEl = document.getElementById('sj-sticky-variant-' + this.dataset.sectionId);
      if (priceEl) priceEl.textContent = this._formatMoney(this._calcTotal());
      if (variantEl && variant.title !== 'Default Title') variantEl.textContent = variant.title;
    }

    _onAddon = () => {
      const variant = this._findVariant();
      if (variant) {
        this._updateAtcText(variant);
        this._updateStickyInfo(variant);
      }
    };

    _initStickyObserver() {
      const anchor = document.getElementById('sj-atc-anchor-' + this.dataset.sectionId);
      const sticky = this.closest('[id^="sj-product-"]')?.nextElementSibling;
      if (!anchor || !sticky?.tagName?.toLowerCase()?.includes('sticky')) return;

      const obs = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          sticky.hidden = entry.isIntersecting;
        });
      }, { threshold: 0 });

      obs.observe(anchor);
    }

    _onSubmit = async (e) => {
      e.preventDefault();
      const sectionId = this.dataset.sectionId;
      const variantId = parseInt(document.getElementById('sj-variant-id-' + sectionId)?.value, 10);
      const qtyInput = this.querySelector('[name="quantity"]');
      const quantity = parseInt(qtyInput?.value || '1', 10);

      const items = [{ id: variantId, quantity }];
      this.querySelectorAll('.sj-addon-card__checkbox:checked').forEach(cb => {
        items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
      });

      const btn = document.getElementById('sj-atc-btn-' + sectionId);
      const textEl = btn?.querySelector('.sj-atc-btn__text');
      const spinner = btn?.querySelector('.sj-atc-btn__spinner');

      if (btn) btn.disabled = true;
      if (textEl) textEl.hidden = true;
      if (spinner) spinner.hidden = false;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error('Cart error');
        const cart = await res.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount: cart.item_count } }
        }));

        if (textEl) { textEl.hidden = false; textEl.textContent = '✓ Added'; }
        if (spinner) spinner.hidden = true;

        setTimeout(() => {
          const variant = this._findVariant();
          if (variant) {
            this._updateAtcText(variant);
            btn.disabled = !variant.available;
          }
        }, 2000);

      } catch (err) {
        if (textEl) textEl.hidden = false;
        if (spinner) spinner.hidden = true;
        const variant = this._findVariant();
        if (variant) {
          this._updateAtcText(variant);
          btn.disabled = !variant.available;
        }
      }
    };
  }

  customElements.define('sj-product-form', SjProductForm);

  class SjStickyAtc extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('.sj-sticky-atc__btn');
      const formId = this.dataset.formId;
      btn?.addEventListener('click', () => {
        document.getElementById(formId)?.requestSubmit();
      });
    }
  }

  customElements.define('sj-sticky-atc', SjStickyAtc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunjunkie-product-education"] && !Shopify.designMode) return;
  try {
    
  class SjEduAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.sj-edu-item__trigger').forEach(trigger => {
        trigger.addEventListener('click', this._onTrigger.bind(this));
      });
    }

    _onTrigger(e) {
      const trigger = e.currentTarget;
      const item = trigger.closest('.sj-edu-item');
      const isOpen = item.classList.contains('is-open');

      this.querySelectorAll('.sj-edu-item.is-open').forEach(open => {
        open.classList.remove('is-open');
        const t = open.querySelector('.sj-edu-item__trigger');
        const p = open.querySelector('.sj-edu-item__panel');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (p) p.setAttribute('aria-hidden', 'true');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        const panel = item.querySelector('.sj-edu-item__panel');
        if (panel) panel.setAttribute('aria-hidden', 'false');
      }
    }
  }

  if (!customElements.get('sj-edu-accordion')) {
    customElements.define('sj-edu-accordion', SjEduAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
